import React, { useEffect } from 'react'
import { ToggleButton, Flex, Popup } from '@leverege/ui-elements'

import { ListItem } from '~/views'

export default function EnumCard( props ) {
  const {
    onSelect,
    onDelete,
    active,
    onClickCard,
    item,
    getValues
  } = props
  useEffect( () => { getValues( item?.type ) }, [] )

  const { type } = item
  const isActive = active?.value?.type === type

  return (
    <ListItem
      onEvent={() => onClickCard( { data : 'enum', value : item } )}
      item={item}
      selected={isActive}
      title={item.name}
      subtitle={item.type}
      rightView={(
        <Flex justify="flex-end">
          <ToggleButton eventData={type} onChange={onSelect} icon="fa fa-fw fa-pencil" />
          <Popup title={(
            <>
              <i className="fa fa-gear fa-fw"/>
              <i style={{ fontSize : 12 }} className="fa-chevron-down fa fa-fw"/>
            </>
          )}>
            <Popup.Item eventData={type} onClick={onDelete}>Delete</Popup.Item>
          </Popup>
        </Flex>
      )} />
  )
}
